import { ErrorRounded } from "@mui/icons-material";
import WarningRounded from "@mui/icons-material/WarningRounded";

export enum SearchInputErrors {
  INSUFFICIENT_CHARACTERS = "INSUFFICIENT_CHARACTERS",
  EXCEED_CHARACTER_COUNT = "EXCEED_CHARACTER_COUNT",
  SPECIAL_CHARACTERS = "SPECIAL_CHARACTERS",
  NO_RESULTS = "NO_RESULTS",
}

type SearchErrorMeta = {
  message: string;
  icon?: React.ComponentType<{ className?: string }>;
  classes?: string;
};

export type SearchResultType = {
  session_id: string;
  session_title: string;
  message_id: string;
  search_query: string;
  matched_sentence: string;
  created_at: string;
  matched_source: "bot_response" | "user_query";
};

export const mapSearchInputErrors: Record<SearchInputErrors, SearchErrorMeta> = {
  [SearchInputErrors.INSUFFICIENT_CHARACTERS]: {
    message: "Begin searching with at least 3 characters",
    icon: WarningRounded,
    classes: "!text-warning-main",
  },
  [SearchInputErrors.EXCEED_CHARACTER_COUNT]: {
    message: "Search is limited to 75 characters.",
    icon: ErrorRounded,
    classes: "!text-text-error-main",
  },
  [SearchInputErrors.SPECIAL_CHARACTERS]: {
    message: "Search term should contain regular text",
    icon: WarningRounded,
    classes: "!text-warning-main",
  },
  [SearchInputErrors.NO_RESULTS]: {
    message: "No matching results found",
    icon: ErrorRounded,
    classes: "!text-text-error-main",
  },
};
